/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { ScrollingModule } from '@angular/cdk/scrolling';
import { NgModule } from '@angular/core';

import { BuilderSharedModule } from '@gh/builder-shared';
import { CoreLazyModule, LAZY_SYMBOLS } from '@gh/core-lazy';

import { ColorPickerModule } from 'ngx-color-picker';

import { BuilderSetupEstimatingRoutingModule } from './builder-setup-estimating-routing.module';
import { ComponentDetailsItemsTabComponent } from './components/component-details-items-tab/component-details-items-tab.component';
import { ComponentDetailsTabContainerComponent } from './components/component-details-tab-container/component-details-tab-container.component';
import { ComponentListTabComponent } from './components/component-list-tab/component-list-tab.component';
import { ComponentOrItemDetailsPictureTabComponent } from './components/component-or-item-details-picture-tab/component-or-item-details-picture-tab.component';
import { CostCenterDetailsComponent } from './components/cost-center-details/cost-center-details.component';
import { EstimatingCostCenterListTabComponent } from './components/estimating-cost-center-list-tab/estimating-cost-center-list-tab.component';
import { ImportPriceNewItemsSubtabComponent } from './components/estimating-import-price-tab/estimating-import-price-subtab/import-price-new-items-subtab/import-price-new-items-subtab.component';
import { EstimatingImportPriceTabComponent } from './components/estimating-import-price-tab/estimating-import-price-tab.component';
import { EstimatingSalesTaxRateDetailsDialogComponent } from './components/estimating-sales-tax-rate-details-dialog/estimating-sales-tax-rate-details-dialog.component';
import { EstimatingSalesTaxRateListTabComponent } from './components/estimating-sales-tax-rates-tab/estimating-sales-tax-rate-list-tab.component';
import { EstimatingTabContainerComponent } from './components/estimating-tab-container/estimating-tab-container.component';
import { EstimatingTakeOffParamDetailsDialogComponent } from './components/estimating-take-off-params-details-dialog/estimating-take-off-param-details-dialog.component';
import { estimatingTakeOffParamDetailsDialog } from './components/estimating-take-off-params-details-dialog/estimating-take-off-param-details-dialog.route';
import { EstimatingTakeOffParamsTabComponent } from './components/estimating-take-off-params-tab/estimating-take-off-params-tab.component';
import { ExportPricesTabComponent } from './components/export-prices-tab/export-prices-tab.component';
import { ItemDetailsTabContainerComponent } from './components/item-details-tab-container/item-details-tab-container.component';
import { ItemsListTabComponent } from './components/items-list-tab/items-list-tab.component';
import { UomDetailsDialogComponent } from './components/uom-details/uom-details-dialog.component';
import { UomListTabComponent } from './components/uom-list-tab/uom-list-tab.component';
import { ComponentDetailsBusinessService } from './resources/component-details-business.service';
import { ComponentListBusinessService } from './resources/component-list-business.service';
import { CostCenterDetailsBusinessService } from './resources/cost-center-details-business.service';
import { EstimatingCostCenterListTabBusinessService } from './resources/estimating-cost-center-list-tab-business.service';
import { EstimatingImportPriceTabBusinessService } from './resources/estimating-import-price-tab-business.service';
import { EstimatingSalesTaxRatesTabBusinessService } from './resources/estimating-sales-tax-rates-tab-business.service';
import { EstimatingTakeOffParamsTabBusinessService } from './resources/estimating-take-off-params-tab-business.service';
import { ExportPriceBusinessService } from './resources/export-prices-business.service';
import { ItemDetailsBusinessService } from './resources/item-details-business.service';
import { ItemsListBusinessService } from './resources/items-list-business.service';
import { UomDetailsBusinessService } from './resources/uom-details-business.service';
import { UomListBusinessService } from './resources/uom-list-business.service';
import { EstimatingFeeExclusionsTabBusinessService } from './resources/estimating-fee-exclusions-tab-business.service';
import { FeeExclusionsListTabComponent } from './components/estimating-fee-exclusions-tab/fee-exclusions-list-tab.component';

export function setupEstimatingLazySymbolsFactory(): Hash<any> {
  return { topDetailsDialogRoute: estimatingTakeOffParamDetailsDialog };
}

@NgModule({
  imports: [
    CoreLazyModule.forChild(),
    BuilderSharedModule.forChild(),
    BuilderSetupEstimatingRoutingModule,
    ScrollingModule,
    ColorPickerModule,
  ],
  providers: [
    { provide: LAZY_SYMBOLS, useFactory: setupEstimatingLazySymbolsFactory, deps: [] },

    EstimatingTakeOffParamsTabBusinessService,
    UomListBusinessService,
    UomDetailsBusinessService,
    EstimatingSalesTaxRatesTabBusinessService,
    CostCenterDetailsBusinessService,
    EstimatingCostCenterListTabBusinessService,
    ItemsListBusinessService,
    ExportPriceBusinessService,
    ItemDetailsBusinessService,
    ComponentListBusinessService,
    ComponentDetailsBusinessService,
    EstimatingImportPriceTabBusinessService,
    EstimatingFeeExclusionsTabBusinessService,
  ],
  declarations: [
    EstimatingTabContainerComponent,
    EstimatingTakeOffParamsTabComponent,
    EstimatingTakeOffParamDetailsDialogComponent,
    UomListTabComponent,
    UomDetailsDialogComponent,
    EstimatingSalesTaxRateListTabComponent,
    EstimatingSalesTaxRateDetailsDialogComponent,
    CostCenterDetailsComponent,
    EstimatingCostCenterListTabComponent,
    ItemsListTabComponent,
    ExportPricesTabComponent,
    ItemDetailsTabContainerComponent,
    ComponentDetailsTabContainerComponent,
    ComponentDetailsItemsTabComponent,
    ComponentOrItemDetailsPictureTabComponent,
    ComponentListTabComponent,
    EstimatingImportPriceTabComponent,
    ImportPriceNewItemsSubtabComponent,
    FeeExclusionsListTabComponent,
  ],
  entryComponents: [
    UomDetailsDialogComponent,
    EstimatingTakeOffParamDetailsDialogComponent,
    EstimatingSalesTaxRateDetailsDialogComponent,
  ],
})
export class BuilderSetupEstimatingModule {
}
